import React from 'react';
import { Slide, Box, SxProps, Theme } from '@mui/material';
import { SettingsComponent, SettingsComponentProps } from './Settings';
import { settings } from './settings.data';

export interface IVideoSettings extends Omit<SettingsComponentProps, 'settings'> {
    qualityOptions?: string[];
    settingsSX?: SxProps<Theme>;
    showSettings: boolean;
}

const VideoSetting: React.FC<IVideoSettings> = props => {
    const { settingsSX, showSettings } = props;

    return (
        <Slide in={showSettings} direction="up" mountOnEnter unmountOnExit>
            <Box
                sx={{
                    position: 'absolute',
                    bottom: '60%',
                    right: '10%',
                    ...settingsSX,
                }}>
                <SettingsComponent settings={settings} {...props} />
            </Box>
        </Slide>
    );
};
VideoSetting.defaultProps = {
    qualityOptions: ['auto', '480', '720', '1080'],
};

export { VideoSetting };
